// composables
import { ref, type Ref } from 'vue'
// composables
import useApiRequest from '@/composables/useApiRequest'
// types
import type { Agreement } from '@/types/domain/agreement'
import type { ExternalSystem } from '@/types/domain/externalDealershipSystem'

/**
 * Composable for managing external systems logins
 * Handles fetching and displaying external system credentials
 */
export default function useAgreementExternalSystems(agreementData: Ref<Agreement | null>) {
  // state
  const externalSystems = ref<ExternalSystem[] | null>(null)

  // api requests
  const externalSystemsRequest = useApiRequest()

  /**
   * Fetches external system logins for the agreement's dealership
   */
  function fetchExternalSystemLogins(): void {
    if (!agreementData.value) {
      return
    }

    externalSystemsRequest
      .send({
        method: 'GET',
        endpoint: '/v1/external-systems',
        params: { dealerships: agreementData.value.dealership.id }
      })
      .then(response => {
        if (response.success) {
          externalSystems.value = response.data as ExternalSystem[] | null
        }
      })
  }

  return {
    // state
    externalSystems,
    // methods
    fetchExternalSystemLogins
  }
}
